<template>
  <div class="new-estate-card"
    :class="[classes, { '_is-small': allCardsAreSmall }]">
    <EstateCardSlider :key="random"
      :image-list="card.images"
      class="new-estate-card__slider"
      @click="estateShow(card.alias)" />

    <div class="new-estate-card__info">
      <div class="new-estate-card__info-head">
        <router-link v-if="card.alias"
          ref="cardLink"
          v-clamp="2"
          class="new-estate-card__info-name"
          to="/new-estate"
          @click="toCard">
          {{ card.title }}
        </router-link>
        <div class="new-estate-card__info-add">
          <div class="new-estate-card__info-address">
            <div>{{ card.location['locality-name'] }}</div>
            <div>{{ card.location.address }}</div>
          </div>
          <div class="new-estate-card__info-when">
            <div class="_uppercase">Срок сдачи:</div>
            <div v-if="card.built_year">{{ replaceNumberQuarter(card.ready_quarter) }} кв. {{ card.built_year }}г.
            </div>
          </div>
        </div>
        <div ref="cardPrice"
          class="new-estate-card__price">
          <span>квартиры от </span>
          <span v-if="card.price"
            class="new-estate-card__price-big"
            v-currency="card.price" />
        </div>
      </div>
      <!-- <div v-if="!isSmall"
        v-clamp="2"
        class="new-estate-card__description">
        <div v-if="card.alias"
          v-html="card.description" />
        <router-link v-if="!isSmall"
          ref="cardLink"
          class="new-estate-card__go"
          :to="{ name: 'Детальная новостройки', params: { alias: card.alias } }">
          Читать далее
        </router-link>
      </div> -->

      <div v-if="card.location.latitude"
        v-show="!isSmall"
        class="new-estate-card__hover-buttons">
        <ButtonLocation @click="openMap = true" />
        <teleport v-if="openMap"
          to="body">
          <AppModal v-model="openMap">
            <ModalMap :coords="[+card.location.latitude, +card.location.longitude]"
              :title="card.title" />
          </AppModal>
        </teleport>
      </div>
    </div>

    <AppButton v-if="map"
      ref="cardLink"
      class="new-estate-card__go-button"
      to="/new-estate"
      :secondary="true">
      Подробнее
    </AppButton>
  </div>
</template>

<script>
import { computed, reactive } from "vue";
import EstateActions from "./EstateActions.vue";
import EstateCardSlider from "./EstateCardSlider.vue";
import SubwayList from "./ui/SubwayList.vue";
import ButtonLocation from "./ui/ButtonLocation.vue";
import AppModal from "./ui/AppModal.vue";
import AppButton from "./ui/AppButton.vue";
import ModalMap from "./ModalMap.vue";
import { mapActions } from "pinia";
import { useFilterStore } from "@/store/filters/filterStore.js";

export default {
  name: "EstateNewCard",
  components: {
    EstateActions,
    EstateCardSlider,
    SubwayList,
    ButtonLocation,
    AppModal,
    AppButton,
    ModalMap,
  },

  provide() {
    return {
      cardLink: computed(() => this.cardLink),
    };
  },

  props: {
    card: {
      type: Object,
      default: () => { },
    },
    isSmall: {
      type: Boolean,
      default: null,
    },
    alias: {
      type: String,
      default: () => "",
    },
    map: {
      type: Boolean,
      default: null,
    },
    doUpdate: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    props = reactive(props);
    return {
      classes: computed(() => ({
        "_is-small": props.isSmall,
      })),
    };
  },

  data() {
    return {
      allCardsAreSmall: false,
      isHoverOn: false,
      openMap: false,
      formPage: null,
      random: 1,
    };
  },

  mounted() {
    this.goSmall();
    this.cardLink = this.$refs.cardLink.$el.href;
    this.emitter.on("updateSlider", this.updateSlider);
  },
  beforeUnmount() {
    this.emitter.off("updateSlider", this.updateSlider);
  },
  methods: {
    ...mapActions(useFilterStore, ["saveScrollForEstateList"]),
    toCard() {
      this.saveScrollForEstateList();
    },
    updateSlider() {
      if (this.doUpdate) {
        this.random = Math.random();
      }
    },
    goSmall() {
      const media = window.matchMedia("(max-width:1023px)");
      const listener = (event) => (this.allCardsAreSmall = event.matches);
      listener(media);

      media.addEventListener("change", listener);
    },

    replaceNumberQuarter(number) {
      let quarter;
      number == 1 ? (quarter = "I кв.") : "";
      number == 2 ? (quarter = "II кв.") : "";
      number == 3 ? (quarter = "III кв.") : "";
      number == 4 ? (quarter = "IV кв.") : "";
      return quarter;
    },

    estateShow(alias) {
      if (!this.allCardsAreSmall) {
        this.$router.push({
          path: "/new-estate",
        });
      } else {
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
._uppercase {
  text-transform: uppercase;
}

/* С таблета делаем две колонки у лонга */
.new-estate-card {
  $that: &;

  position: relative;
  text-align: left;
  display: flex;
  flex-direction: column;
  transition: background-color 0.3s ease;
  background-color: $white;
  border-bottom-right-radius: 90px;

  .map & {
    background-color: $white;
  }

  @include tablet {
    display: block;
  }

  &:hover {
    background-color: $color_orange-50;

    #{$that} {
      &__price {
        color: $white
      }
    }
  }

  &._is-small {
    display: block;
  }

  &__slider {
    flex: none;
    width: calc(438 / 1920 * 100vw);
    min-width: 292px;
    cursor: pointer;

    @include tablet {
      min-height: 212px;
      min-width: 100%;
    }

    ._is-small & {
      width: 100% !important;
      min-width: 100%;
      min-height: auto;
    }
  }

  &__info {
    position: relative;
    padding: 40px calc(56 / 1920 * 100vw) 52px 56px;

    ._is-small & {
      // padding: 38px calc(24 / 1920 * 100vw) 52px 56px;
      padding: 20px;

      @include laptop {
        padding: 14px 16px 0;
      }

      @include phone {
        padding-bottom: 34px;
      }
    }

    @include desktop {
      padding: 30px calc(20 / 1535 * 100vw) 132px 30px calc(20 / 1535 * 100vw);
    }

    @include laptop {
      padding: 16px;
    }
  }

  &__info-add {
    display: flex;
    justify-content: space-between;
  }

  &__info-head {
    display: flex;
    flex-direction: column;
  }

  &__info-name {
    overflow: hidden;
    color: $color_dark-90;
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 18px;

    @include laptop {
      font-size: 20px;
      line-height: 26px;
      margin-bottom: 10px;
    }

    ._is-small & {
      height: calc(20px * 2);
      font-size: 20px;
      line-height: 20px;

      @include laptop {
        font-size: 18px;
      }
    }
  }

  &__info-when {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    text-align: left;
    flex: none;
    margin-left: 28px;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 32px;

    @include laptop {
      margin-left: 22px;
    }

    @include phone {
      // display: none;
    }

    ._is-small & {
      flex-direction: column;
      justify-content: flex-start;
      text-align: right;
    }
  }

  &__info-material {
    @include tablet {
      display: none;
    }
  }

  &__info-address {
    position: relative;
    color: $color_dark-50;
    font-size: 14px;
    line-height: 22px;

    @include laptop {
      font-size: 14px;
      line-height: 18px;
    }

    ._is-small & {
      color: $color_dark-90;
      font-size: 14px;
      line-height: 22px;
    }
  }

  &__price {
    transition: color 0.3s ease;
    font-size: 20px;
    line-height: 22px;
    color: $color_orange-50;

    // @include laptop {
    //   font-size: 20px;
    //   line-height: 22px;
    // }

    ._is-small & {
      text-align: left;
      font-size: 20px;
      line-height: 22px;

      @include phone {
        font-size: 16px;
        line-height: 120%;
      }
    }

    &-big {
      font-size: 36px;

      @include phone {
        font-size: 22px;
      }
    }
  }
}
</style>
